import React, { useState } from "react";
import { Button } from "@nextui-org/react";
import ReactSelect from "./ReactSelect"; // Import komponen React Select Anda
import toast from "react-hot-toast";
import { getFetcher, getSelectFetcher } from "../../services/api";
import useSWR from "swr";

export default function FilterInTab({ filters, onApply, disableMonth, disableProvince = true }) {
  const [selectedProvince, setSelectedProvince] = useState('');
  const monthNames = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const currentDate = new Date();
  const defaultMonth = currentDate.getMonth() + 1;
  const defaultYear = currentDate.getFullYear();

  const months = monthNames.map((name, index) => ({
    value: index + 1,
    label: name,
  }));

  const years = Array.from({ length: 8 }, (_, i) => ({
    value: new Date().getFullYear() - i,
    label: `${new Date().getFullYear() - i}`,
  }));

  // State untuk filter
  const [startMonth, setStartMonth] = useState(filters?.startMonth || defaultMonth);
  const [startYear, setStartYear] = useState(filters?.startYear || defaultYear);
  const [endMonth, setEndMonth] = useState(filters?.endMonth || defaultMonth);
  const [endYear, setEndYear] = useState(filters?.endYear || defaultYear);
  const [year, setYear] = useState(filters?.year || defaultYear);
  const { data: provinces } = useSWR('/api/location/provinces', getFetcher);
  const provinces2 = provinces?.map((item) => ({
    value: item.id,
    label: item.name,
  })) || [];
  const handleApply = () => {
    if (disableMonth && disableProvince) {
      // Validasi jika hanya tahun
      if (!year) {
        toast.error("Tahun harus diisi sebelum menerapkan filter!");
        return;
      }
      onApply({ year: year?.value });
    } 
    else if (!disableProvince){
      if (!disableProvince && !selectedProvince) {
        toast.error("Provinsi harus dipilih sebelum menerapkan filter!");
        return;
      }
      onApply({ year: year?.value, provinceId:  selectedProvince?.value });
    }
    else {
      // Validasi jika bulan dan tahun
      if (
        !startYear ||
        !endYear ||
        !startMonth ||
        !endMonth ||
        startYear?.value > endYear?.value ||
        (startYear?.value === endYear?.value && startMonth?.value > endMonth?.value)
      ) {
        toast.error("Tanggal awal harus lebih kecil atau sama dengan tanggal akhir!");
        return;
      }

      onApply({
        startMonth: startMonth?.value,
        startYear: startYear?.value,
        endMonth: endMonth?.value,
        endYear: endYear?.value,
        provinceId:  selectedProvince?.value
      });
    }
  };
  return (
    <div className="mb-4 flex flex-wrap gap-4 items-end">
      {disableMonth ? (
        // Filter hanya untuk tahun
        <ReactSelect
          data={years}
          value={year}
          onChange={(option) => setYear(option)}
          label="Tahun"
        />
      ) : (
        // Filter untuk bulan dan tahun
        <>
          <ReactSelect
            data={months}
            value={startMonth}
            onChange={(option) => setStartMonth(option)}
            label="Bulan Awal"
          />
          <ReactSelect
            data={years}
            value={startYear}
            onChange={(option) => setStartYear(option)}
            label="Tahun Awal"
          />
          <ReactSelect
            data={months}
            value={endMonth}
            onChange={(option) => setEndMonth(option)}
            label="Bulan Akhir"
          />
          <ReactSelect
            data={years}
            value={endYear}
            onChange={(option) => setEndYear(option)}
            label="Tahun Akhir"
          />
        </>
      )}{!disableProvince && (
        <ReactSelect
          data={provinces2}
          value={selectedProvince}
          onChange={(option) => setSelectedProvince(option)}
          label="Provinsi"
        />
      )}
      <Button size="sm" color="primary" onClick={handleApply}>
        Terapkan
      </Button>
    </div>
  );
}
